module.exports = __webpack_public_path__ + "ba1f2282c2529c7a3bdb47163cecb7a2.pdf";